import { useQuery } from "react-query";
import axios from "infra/http";
import {HistoricoCobrancaItemResponse} from '../typings'

function useHistoricoCobranca(unidadeId?: string) {
  return useQuery(
    [`/v1/historico-cobranca`],
    async () => {
      const res = await axios.get<HistoricoCobrancaItemResponse[]>(`/v1/historico-cobranca`, {
        params:{
          unidadeId
        }
      });

      return res.data;
    }, {
      enabled: !!unidadeId,
    }
  );
}

export default useHistoricoCobranca;
